import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type JobDataResultQueryVariables = Types.Exact<{
  jobDataInput: Types.JobDataInput;
}>;


export type JobDataResultQuery = { __typename?: 'Query', jobData: { __typename?: 'JobDataPayload', results: Array<{ __typename?: 'JobDataResult', job: { __typename?: 'Job', key: string, tracking?: { __typename?: 'JobTrackingResult', jobClick: { __typename?: 'JobTrackingJobClickResult', url?: string | null } } | null }, matchComparisonResult?: { __typename?: 'MatchComparisonEngineMatchResult', encouragementToApply?: { __typename?: 'MatchComparisonEngineEncouragementToApply', trafficLight?: Types.MatchComparisonEngineTrafficLightSignal | null, score?: number | null, strategy?: string | null } | null, attributeComparisons?: Array<{ __typename?: 'MatchComparisonEngineAttributeComparison', jobProvenance?: Types.MatchComparisonEngineProvenance | null, jsProvenance?: Types.MatchComparisonEngineProvenance | null, jobRequirementStrength?: Types.MatchComparisonEngineRequirementStrength | null, matchType?: Types.MatchComparisonEngineMatchType | null, attribute?: { __typename?: 'MatchComparisonEngineAttribute', label?: string | null, suid?: string | null, interestedParty?: Types.MatchComparisonEngineInterestedParty | null, lastModified?: number | null, profileAttributeTypeSuid?: string | null } | null }> | null } | null }> } };


export const JobDataResultDocument = gql`
    query JobDataResult($jobDataInput: JobDataInput!) {
  jobData(input: $jobDataInput) {
    results {
      job {
        key
        tracking {
          jobClick {
            url
          }
        }
      }
      matchComparisonResult {
        encouragementToApply {
          trafficLight
          score
          strategy
        }
        attributeComparisons {
          jobProvenance
          jsProvenance
          attribute {
            label
            suid
            interestedParty
            lastModified
            profileAttributeTypeSuid
          }
          jobRequirementStrength
          matchType
        }
      }
    }
  }
}
    `;

/**
 * __useJobDataResultQuery__
 *
 * To run a query within a React component, call `useJobDataResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDataResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDataResultQuery({
 *   variables: {
 *      jobDataInput: // value for 'jobDataInput'
 *   },
 * });
 */
export function useJobDataResultQuery(baseOptions: Apollo.QueryHookOptions<JobDataResultQuery, JobDataResultQueryVariables> & ({ variables: JobDataResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDataResultQuery, JobDataResultQueryVariables>(JobDataResultDocument, options);
      }
export function useJobDataResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDataResultQuery, JobDataResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDataResultQuery, JobDataResultQueryVariables>(JobDataResultDocument, options);
        }
export function useJobDataResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobDataResultQuery, JobDataResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobDataResultQuery, JobDataResultQueryVariables>(JobDataResultDocument, options);
        }
export type JobDataResultQueryHookResult = ReturnType<typeof useJobDataResultQuery>;
export type JobDataResultLazyQueryHookResult = ReturnType<typeof useJobDataResultLazyQuery>;
export type JobDataResultSuspenseQueryHookResult = ReturnType<typeof useJobDataResultSuspenseQuery>;
export type JobDataResultQueryResult = Apollo.QueryResult<JobDataResultQuery, JobDataResultQueryVariables>;